"use strict"
angular.module("manageSysManageEditSyncSignModule", [])
    .controller("manageSysManageEditSyncSignCtrl", ['$scope', '$q', 'trsHttpService', '$state', '$filter', '$timeout', 'trsColumnTreeLocationService', '$validation', 'modalDialog', 'trsspliceString',
        function($scope, $q, trsHttpService, $state, $filter, $timeout, trsColumnTreeLocationService, $validation, modalDialog, trsspliceString) {
            initStatus();
            initData();

            /**
             * [initStatus 初始化状态]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.list = {
                    RelName: '',
                    SrcChannelId: '',
                    TarChannelId: '',
                    RelStatus: 0,
                    RelType: 0,
                };

                $scope.page = {
                    "CURRPAGE": 1,
                    "PAGESIZE": 50,
                    "ITEMCOUNT": 0,
                    "PAGECOUNT": 1
                };

                $scope.status = {
                    isNew: angular.isDefined($state.params.relid) ? false : true,
                    treeOptions: {
                        nodeChildren: "CHILDREN",
                        dirSelectable: true,
                        allowDeselect: false,
                        injectClasses: {
                            ul: "a1",
                            li: "a2",
                            liSelected: "a7",
                            iExpanded: "a3",
                            iCollapsed: "a4",
                            iLeaf: "a5",
                            label: "a6",
                            labelSelected: "a8"
                        },
                        isLeaf: function(node) {
                            return node.HASCHILDREN == "false";
                        }
                    },
                    // appTreeOptions: {},
                    direction: [{
                        name: '客户端单向同签到网站',
                        value: '1',
                    }, {
                        name: "客户端与网站双向同签",
                        value: '2',
                    }],
                    selectedDirection: {
                        name: '客户端单向同签到网站',
                        value: '1',
                    },
                    selectedChannel: 'app',
                    mediaType: { //渠道分类
                        app: "1",
                        website: "2",
                        newspaper: "3",
                        weixin: "4",
                        weibo: "5",
                        scapp: "",
                        television: "15",
                        broadcast: "16"
                    },
                    selectedArr: {
                        website: {},
                        app: {},
                    }
                };

                $scope.data = {
                    app: {
                        items: [],
                        columns: [],
                        selectedNode: {},
                        pathArray: [],
                        expandedTest: [],
                    },
                    website: {
                        items: [],
                        columns: [],
                        selectedNode: {},
                        pathArray: [],
                        expandedTest: [],
                    },
                    detail: '',
                    originalApp: [],
                    originalWebsite: [],
                };
            }

            /**
             * [initData 初始化数据]
             * @return {[type]} [description]
             */
            function initData() {
                if (!$scope.status.isNew) {
                    queryDataById().then(function() {
                        return querySiteForMediaType($scope.status.mediaType[$scope.status.selectedChannel], $scope.status.selectedChannel);
                    }).then(function() {
                        return getWebsiteColumn();
                    }).then(function() {
                        dataBackfill();
                    });
                } else {
                    querySiteForMediaType($scope.status.mediaType[$scope.status.selectedChannel], $scope.status.selectedChannel).then(function() {
                        getWebsiteColumn();
                    });
                }
            }

            /**
             * [queryDataById 获取配置详情]
             * @return {[type]} [description]
             */
            function queryDataById() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_publishinsametime',
                    methodname: 'queryPublishChannelRels',
                    PublishChannelRelIds: $state.params.relid
                    // RelName: $scope.data.keywords,
                    // PageSize: $scope.page.PAGESIZE,
                    // CurrPage: $scope.page.CURRPAGE
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.detail = data.DATA[0];
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [dataBackfill 数据回填]
             * @return {[type]} [description]
             */
            function dataBackfill() {
                var detail = $scope.data.detail;
                $scope.list.RelName = detail.RELNAME;
                $scope.list.RelStatus = detail.RELSTATUS;
                $scope.status.selectedDirection = $scope.status.direction.filter(function(item){
                	return item.value == detail.RELTYPE;
                })[0];
                handleAppData(detail);
                handleWebsiteData(detail);
            }

            /**
             * [handleAppData 处理app数据]
             * @param  {[type]} detail [description]
             * @return {[type]}        [description]
             */
            function handleAppData(detail) {
                var site = $scope.data.app.items.filter(function(item) {
                    return item.SITEID == detail.SRCCHANNELINFO.SiteId;
                })[0];
                var node = detail.SRCCHANNELINFO;
                // var channelName = node.ChannelPath.split('-');
                $scope.data.app.pathArray.push({
                    mediaName: 'APP',
                    mediaType: "",
                    siteName: site.SITEDESC,
                    // channelName: channelName[channelName.length - 1],
                    channelId: node.ChannelId,
                    fullPath: node.ChannelPath,
                });
                $scope.status.selectedArr.app[site.SITEID] = node.ChannelId;
                $scope.data.originalApp.push(node.ChannelId);
            }

            /**
             * [handleWebsiteData 处理website数据]
             * @param  {[type]} detail [description]
             * @return {[type]}        [description]
             */
            function handleWebsiteData(detail) {
                querySiteForMediaType($scope.status.mediaType.website, 'website').then(function() {
                    return getWebsiteColumn();
                }).then(function() {
                    var sites = detail.TARCHANNELINFO;
                    var site, node, channelName;
                    for (var i = 0; i < sites.length; i++) {
                        site = $scope.data.website.items.filter(function(item) {
                            return item.SITEID == sites[i].SITEID;
                        })[0];
                        node = sites[i];
                        // channelName = node.CHANNELPATH.split('-');
                        $scope.data.website.pathArray.push({
                            mediaName: '网站',
                            mediaType: "",
                            siteName: site.SITEDESC,
                            // channelName: channelName[channelName.length - 1],
                            channelId: node.CHANNELID,
                            fullPath: node.CHANNELPATH,
                        });
                        $scope.status.selectedArr.website[site.SITEID] = node.CHANNELID;
                        $scope.data.originalWebsite.push(node.CHANNELID);
                    }
                });

            }

            /**
             * [switchStatus 切换状态]
             * @param  {[type]} value [description]
             * @return {[type]}       [description]
             */
            $scope.switchStatus = function(value) {
                $scope.list.RelStatus = value;
            };

            /**
             * [switchChannel 切换渠道]
             * @param  {[type]} channel [description]
             * @return {[type]}         [description]
             */
            $scope.switchChannel = function(channel) {
                if ($scope.status.selectedChannel == channel) return;
                $scope.status.selectedChannel = channel;
                if ($scope.data[channel].items.length == 0) {
                    querySiteForMediaType($scope.status.mediaType[$scope.status.selectedChannel], $scope.status.selectedChannel).then(function() {
                        getWebsiteColumn();
                    });
                }
            };

            /**
             * [querySiteForMediaType 查询各渠道下的站点]
             * @param  {[type]} type    [description]
             * @param  {[type]} channel [description]
             * @return {[type]}         [description]
             */
            function querySiteForMediaType(type, channel) {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_mediasite',
                    methodname: 'queryWebSitesByMediaType',
                    MediaType: type ? type : "1",
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    data.DATA.forEach(function(item, index) {
                        item.CHANNELID = item.ACCOUNTID != undefined ? item.ACCOUNTID : item.CHANNELID;
                        item.CHNLDESC = item.ACCOUNTNAME != undefined ? item.ACCOUNTNAME : item.CHNLDESC;
                    });
                    $scope.data[channel].items = data.DATA;
                    $scope.data[channel].selectedItem = data.DATA[0];
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [getWebsiteColumn 查询各站点下的栏目]
             * @return {[type]} [description]
             */
            function getWebsiteColumn() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_mediasite',
                    methodname: 'queryClassifyBySite',
                    SiteId: $scope.data[$scope.status.selectedChannel].selectedItem.SITEID,
                    platform: 1, // 管理员有所有权限，此处默认传待编平台标识
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    // $scope.data[$scope.status.selectedChannel].expandedTest = [];
                    $scope.data[$scope.status.selectedChannel].columns = data;
                    if (angular.isDefined($scope.data[$scope.status.selectedChannel].columns.CHILDREN)) {
                    	judgeConfigType($scope.data[$scope.status.selectedChannel].columns.CHILDREN);
                    }
                    defer.resolve();
                });
                return defer.promise;
            }

            //异步加载树
            $scope.showToggle = function(node) {
                childrenTree(node).then(function(data) {
                    return judgeConfigType(data);
                });
            };

            /**
             * [childrenTree 获取组织树下级]
             * @param  {[type]} node [description]
             * @return {[type]}      [description]
             */
            function childrenTree(node) {
                var deffer = $q.defer();
                if (node.HASCHILDREN == "true" && (angular.isUndefined(node.CHILDREN) || node.CHILDREN.length === 0)) {
                    var params = {
                        "serviceid": "mlf_mediasite",
                        "methodname": "queryClassifyByChnl",
                        "ChannelId": node.CHANNELID,
                        "platform": 1,
                    };
                    trsHttpService.httpServer("/wcm/mlfcenter.do", params, "get").then(function(data) {
                        node.CHILDREN = data.CHILDREN;
                        deffer.resolve(data.CHILDREN);
                    });
                }
                return deffer.promise;
            }

            /**
             * [judgeConfigType 判断是否存在配置项]
             * @param  {[type]} node [description]
             * @return {[type]}      [description]
             */
            function judgeConfigType(node) {
                var params = {
                    serviceid: 'mlf_publishinsametime',
                    methodname: 'queryRelsTypeByChannelId',
                    ChannelIds: trsspliceString.spliceString(node, 'CHANNELID', ',')
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    for (var i = 0; i < node.length; i ++) {
                    	if (data[node[i].CHANNELID] != 0 ) {
                    		node[i].disabled = true;
                    	}
                    }
                });
            }

            /**
             * [setSite 选择站点]
             * @param {[type]} item [description]
             * @param {[type]} type [description]
             */
            $scope.setSite = function(item, type) {
                $scope.data[type].selectedItem = item;
                getWebsiteColumn();
            };

            $scope.getChannel = function(node, $event) {
                getChannel(node)
            }

            /**
             * [getChannel description] 点击三级站点或版面
             * @param  {[type]} node   [description] 当前节点
             * @param  {[type]} $event [description] 当前事件
             * @return {[type]}        [description]
             */
            function getChannel(node, $event) {
                $scope.data.channelFilter = "";
                $scope.data.appChannelFilter = "";
                getSelectedChannel(node, $event);
            }

            function getSelectedChannel(node, $event) {
                console.log(node)
                var type = $scope.status.selectedChannel;
                if (type == 'app') {
                    if (JSON.stringify($scope.status.selectedArr.app) == '{}') {
                        $scope.status.selectedArr[type][$scope.data[type].selectedItem.SITEID] = node.CHANNELID;
                    } else { //不为空的情况判断是否为不同站点，不同站点的话app需删除之前站点
                        for (var k in $scope.status.selectedArr.app) {
                            if (k != $scope.data.app.selectedItem.SITEID) {
                                delete $scope.status.selectedArr.app[k];
                            }
                        }
                        $scope.status.selectedArr[type][$scope.data[type].selectedItem.SITEID] = node.CHANNELID;
                    }
                    if ($scope.data[type].pathArray.length > 0) {
                        $scope.data[type].pathArray = [];
                    }
                    $scope.data[type].pathArray.push({
                        mediaName: type == 'app' ? 'APP' : '网站',
                        mediaType: "",
                        siteName: $scope.data[type].selectedItem.SITEDESC,
                        channelName: node.CHNLDESC,
                        channelId: node.CHANNELID
                    });
                } else {
                    $scope.status.selectedArr[type][$scope.data[type].selectedItem.SITEID] = node.CHANNELID;
                    var obj = {
                        mediaName: type == 'app' ? 'APP' : '网站',
                        mediaType: "",
                        siteName: $scope.data[type].selectedItem.SITEDESC,
                        channelName: node.CHNLDESC,
                        channelId: node.CHANNELID
                    };
                    if ($scope.data[type].pathArray.length == 0) {
                        $scope.data[type].pathArray.push(obj);
                    } else {
                        var flag = false;
                        for (var i = 0; i < $scope.data[type].pathArray.length; i++) {
                            if ($scope.data[type].pathArray[i].siteName == obj.siteName) {
                                $scope.data[type].pathArray[i] = obj;
                                flag = true;
                            }
                        }
                        if (!flag) {
                            $scope.data[type].pathArray.push(obj);
                        }
                    }
                }
            }

            var promise;
            $scope.getSuggestions = function(channelName) {
                if (channelName === "")
                    return;
                if (promise) {
                    $timeout.cancel(promise);
                    promise = null;
                }
                var type = $scope.status.selectedChannel;
                var siteid = $scope.data[type].selectedItem.SITEID;
                promise = $timeout(function() {
                    var params = {
                        serviceid: "mlf_mediasite",
                        methodname: "queryRightClassifyByName",
                        ChannelName: channelName,
                        SiteId: siteid
                    };
                    return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get")
                        .then(function(data) {
                            return data;
                        });
                }, 500);
                return promise;
            };

            $scope.$watch("data.channelFilter", function(newValue, oldValue) {
                if (angular.isObject(newValue)) {
                    //初始化树数据
                    getWebsiteColumn($scope.data[$scope.status.selectedChannel].selectedItem);
                    //清空树展开
                    $scope.data[$scope.status.selectedChannel].expandedTest = [];
                    //重新定位树展开位置
                    //getPositionData(newValue.CHANNELID);
                    // $timeout(function() {
                    trsColumnTreeLocationService.columnTreeLocation(
                        1,
                        newValue.CHANNELID,
                        $scope.data[$scope.status.selectedChannel].columns,
                        $scope.data[$scope.status.selectedChannel].selectedNode,
                        $scope.data[$scope.status.selectedChannel].expandedTest,
                        function(tree, array) {
                            delete $scope.data[$scope.status.selectedChannel].columns;
                            $scope.data[$scope.status.selectedChannel].columns = tree;
                            $scope.status.selectedArr[$scope.status.selectedChannel][$scope.data[$scope.status.selectedChannel].selectedItem.SITEID] = array.pop();
                            getSelectedChannel(newValue);
                        });
                    // }, 800)
                }
            });

            /**
             * [goBack 返回]
             * @return {[type]} [description]
             */
            $scope.goBack = function() {
                $state.go('manageconfig.sysmanage.syncsign');
            };

            /**
             * [confirm 保存]
             * @return {[type]} [description]
             */
            $scope.confirm = function() {
                $validation.validate($scope.editSyncSign).success(function() {
                    if ($scope.data.app.pathArray.length == 0) {
                        modalDialog.alertType('请选择一个客户端渠道', '', 'info', 'confirm');
                        return;
                    } else if ($scope.data.website.pathArray.length == 0) {
                        modalDialog.alertType('请选择所需网站渠道', '', 'info', 'confirm');
                        return;
                    }
                    save();
                }).error(function() {
                    modalDialog.alertType('请检查表单填写项', '', 'info', 'confirm')
                });
            }

            /**
             * [save 保存方法]
             * @return {[type]} [description]
             */
            function save() {
                var params = {
                    serviceid: 'mlf_publishinsametime',
                    methodname: 'savePublishChannelRel',
                    PublishChannelRelId: $scope.status.isNew ? 0 : $state.params.relid,
                    RelName: $scope.list.RelName,
                    SrcChannelId: trsspliceString.spliceString($scope.data.app.pathArray, 'channelId', ','),
                    TarChannelIds: trsspliceString.spliceString($scope.data.website.pathArray, 'channelId', ','),
                    RelStatus: $scope.list.RelStatus,
                    RelType: $scope.status.selectedDirection.value,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.ISSUCCESS === 'true') {
                        modalDialog.alertType(data.DETAIL, '', 'success', false, function() {
                            $scope.goBack();
                        });
                    } else {
                        modalDialog.alertType(data.DETAIL, '', 'error', false, function() {
                            return;
                        });
                    }
                })
            }

            /**
             * [deleteApp 删除app渠道]
             * @return {[type]} [description]
             */
            $scope.deleteApp = function() {
                $scope.data.app.pathArray = [];
                $scope.status.selectedArr.app = {};
            };

            /**
             * [deleteWebsite 删除网站渠道]
             * @param  {[type]} index [description]
             * @param  {[type]} item  [description]
             * @return {[type]}       [description]
             */
            $scope.deleteWebsite = function(index, item) {
                $scope.data.website.pathArray.splice(index, 1);
                for (var key in $scope.status.selectedArr.website) {
                    if ($scope.status.selectedArr.website[key] == item.channelId) {
                        delete $scope.status.selectedArr.website[key];
                    }
                }
            };
        }
    ]);